export const ReservationPerDate = [
	"予約サイト名",
	"宿泊日",
	"予約ID",
	"予約成立日",
	"最終予約更新日",
	"チェックイン日",
	"チェックアウト日",
	"泊数",
	"宿泊者氏名",
	"宿泊者氏名（カナ）",
	"部屋マスタ",
	"キャンセル済み部屋マスタ",
	"プラン名称",
	"キャンセル済みプラン名称",
	"部屋数",
	"大人人数",
	"子供人数",
	"ホテルチケット",
	"ディスカウント前金額",
	"ディスカウント",
	"プラン売上金額",
	"お部屋売上金額",
	"オプション売上金額",
	"全ての宿泊予約に対して課する料金合計",
	"請求料金",
	"支払方法",
	"オプション",
	"キャンセル済みオプション",
	"チェックイン時刻",
	"メールアドレス",
	"郵便番号",
	"住所",
	"電話番号",
	"キャンセル日",
	"備考",
	"NO SHOW",
	"スタッフメモ",
	"ホテル名",
	"ホテル所在地",
	"作成日時",
];
